// src/tenancy/constants.ts
var GLOBAL_TENANT = "main";
var GLOBAL_TENANT_COMPOSITE = "main-main";

export { GLOBAL_TENANT, GLOBAL_TENANT_COMPOSITE };
//# sourceMappingURL=chunk-BJ3WKLB6.js.map
//# sourceMappingURL=chunk-BJ3WKLB6.js.map